<template>
	<Row class="page-container-row">
		<Col
			:span="24"
			:offset="0"
		>
			<PageContainer>
				<div class="scrollable-x">
					<div class="flex-wrapper">
						<TypographyTitle :level="2" class="flex-grow">
							{{ $t('baselines.header') }}
						</TypographyTitle>
						<div class="buttons-container">
							<Button class="width-100" type="primary" @click="onAddButtonClick">
								<PlusCircleOutlined />{{ $t('baselines.addButtonLabel') }}
							</Button>
						</div>
					</div>
					<InfoInlineHint v-if="!isBrdcEnabled && !isLoading">
						<BaselineBrdcInfoInlineHintContent />
					</InfoInlineHint>
					<Table
						class="baselines-table"
						:columns="columns"
						:data-source="baselines"
						:pagination="false"
						:loading="isLoading"
					>
						<template #bodyCell="{ column, record }">
							<template v-if="column.key === 'id'">
								<router-link :to="{ name: 'baselines-edit', params: { id: record.id } }">
									{{ $t('baselines.lineId') }} {{ record.id }}
								</router-link>
								<div v-if="record.description">
									<TypographyText type="secondary">{{ record.description }}</TypographyText>
								</div>
							</template>
							<template v-else-if="column.key === 'statusOnline'">
								<Badge :status="record.statusData.badge" :text="$t('baselines.statuses.' + record.statusData.key)" /><br>
							</template>
							<template v-else-if="column.key === 'selected_gnss'">
								<GnssTag
									v-for="code in record.selected_gnss"
									class="margin-after"
									:key="code"
									:code="code"
								/>
							</template>
							<template v-else-if="column.key === 'actions'">
								<ChangeStatusActionBar :target="record" :store="baselinesStore" mode="baseline" />
							</template>
							<template v-else-if="['base', 'rover'].includes(column.key)">
								<BaseStationInBaselineStatus :baseStation="record[column.key]" />
							</template>
						</template>
					</Table>
				</div>
			</PageContainer>
		</Col>
	</Row>
</template>

<script>
import { computed } from 'vue';
import { TypographyTitle, Table, Button, Row, Col, Badge, TypographyText } from 'ant-design-vue';
import { PlusCircleOutlined } from '@ant-design/icons-vue';

import { useRouter } from 'vue-router';

import Consts from '@/api/Consts';

import { useBaselinesStore } from '@/stores/baselinesStore';

import { addBaselineStatusData } from '@/components/addBaseline/baselineUtils';

import GnssTag from '@/components/common/GnssTag';

import InfoInlineHint from '@/components/common/InfoInlineHint';
import BaselineBrdcInfoInlineHintContent from '@/components/common/BaselineBrdcInfoInlineHintContent';
import PageContainer from '@/components/common/PageContainer';

import ChangeStatusActionBar from '@/components/baseStations/ChangeStatusActionBar';

import BaseStationInBaselineStatus from '@/components/addBaseline/BaseStationInBaselineStatus';


export default {
	components: {
		TypographyTitle, Button, Row, Col, Table, Badge, TypographyText, GnssTag, PageContainer, ChangeStatusActionBar,
		PlusCircleOutlined, InfoInlineHint, BaselineBrdcInfoInlineHintContent,
		BaseStationInBaselineStatus,
	},
	setup() {
		const baselinesStore = useBaselinesStore();
		const router = useRouter();

		const columns = Consts.baselinesTableColumnsComp;

		const baselines = computed(() => baselinesStore.items.map(addBaselineStatusData));
		const isLoading = computed(() => baselinesStore.isLoading && baselinesStore.items.length === 0);
		const isBrdcEnabled = computed(() => baselinesStore.settings.brdc_enabled);

		const onAddButtonClick = () => router.push({ name: 'add-baseline' });
		return {
			columns,
			baselines,
			isBrdcEnabled,
			isLoading,
			onAddButtonClick,
			baselinesStore,
		};
	},
}
</script>

<style>
.baselines-table .ant-typography code {
	display: inline-block;
}
</style>

<style scoped>
.buttons-container {
	margin-bottom: 16px;
}

.margin-after {
	margin-block-end: 4px;
}
</style>
